<template>
  <loan-status-alert-container :loan="loan">
    <template #borrower>
      <p>
        {{ $t("components.loan.status.alerts.waiting.borrower.message") }}
      </p>
    </template>

    <template #owner>
      <p>
        {{ $t("components.loan.status.alerts.waiting.owner.message") }}
      </p>
      <p v-if="loan.waiting_for_loan_id" class="mb-0">
        {{
          $t("components.loan.status.alerts.waiting.owner.waiting_for", {
            id: loan.waiting_for_loan_id,
          })
        }}
      </p>
    </template>

    <template #admin>
      <p>
        {{ $t("components.loan.status.alerts.waiting.admin.message") }}
      </p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";

export default {
  name: "LoanWaiting",
  components: {
    LoanStatusAlertContainer,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
};
</script>
